module.exports = __webpack_public_path__ + "static/img/city-mob-gold-1.0f1f979.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gold-about/city-mob-gold-1.png
// module id = 1244
// module chunks = 4